<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to=''>会员中心</router-link></li>
                <li class="currentNode"><a>上传驻京美食</a></li>
                <!-- <li><router-link to="/layout/upload-food-add" >添加</router-link></li> -->
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>上传驻京美食</h3>
                    <el-form label-width="100px" :model="form" :rules="rules" @submit.native.prevent ref="ruleForm" class="form" size="small">
                        <el-form-item label="店铺名称" prop="name">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="地址" prop="address">
                            <el-input v-model="form.address"></el-input>
                        </el-form-item>
                        <el-row :gutter="50">
                            <el-col :span="12">
                                <el-form-item label="电话" prop="tel">
                                    <el-input v-model="form.tel"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="人均价格" prop="perPrice">
                                    <el-input v-model="form.perPrice"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!-- <el-form-item label="介绍" prop="des">
                            <el-input type="texarea" v-model="form.des"></el-input>
                        </el-form-item> -->
                        <el-form-item label="区域" prop="mapArea">
                            <el-radio-group v-model="form.mapArea" @change="changeArea()">
                                <el-radio 
                                    v-for="item in mapAreaList"
                                    :key="item.value"
                                    :label="item.label"
                                >
                                    {{ item.label }}
                                </el-radio>
                            </el-radio-group>
                                    <!-- <el-select v-model="form.mapArea" placeholder="请选择">
                                        <el-option
                                        v-for="item in mapAreaList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select> -->
                        </el-form-item>
                        <el-form-item label="菜系" prop="cookingStyle">
                            <el-radio-group v-model="form.cookingStyle">
                                <el-radio 
                                    v-for="item in cookingStyleList"
                                    :key="item.value"
                                    :label="item.label"
                                >
                                    {{ item.label }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="标签" prop="tags">
                            <el-tag
                                :key="tag"
                                v-for="tag in tagList"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(tag)">
                                {{ tag }}
                            </el-tag>
                            <el-input
                                class="input-new-tag"
                                v-if="inputVisible"
                                v-model="tagVlaue"
                                ref="saveTagInput"
                                size="small"
                                @blur="handleInputConfirm"
                                >
                                </el-input>
                                <el-button v-else type="primary" class="button-new-tag" size="small" @click="showInput"><i class="el-icon-circle-plus"></i>添加</el-button>
                        </el-form-item>
                        <el-row :gutter="50">
                            <el-col :span="12">
                                <el-form-item label="封面图" prop="coverImageUrl">
                                    <el-upload
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :on-preview="handlePreview"
                                        :on-remove="handleRemove"
                                        :before-remove="beforeRemove"
                                        multiple
                                        :limit="1"
                                        :on-exceed="handleExceed"
                                        :on-success="uploadSuccess"
                                        :file-list="coverImageList"
                                        list-type="picture">
                                        <el-button size="small" style="width:350px;border-radius:0;"><i class="el-icon-upload"></i>点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip"><i class="el-icon-info"></i>推荐尺寸：289 x 166，1张</div>
                                        </el-upload>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="餐厅照片" prop="restaurantImageUrls">
                                    <el-upload
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :on-preview="handlePreviewRestaurant"
                                        :on-remove="handleRemoveRestaurant"
                                        :before-remove="beforeRemoveRestaurant"
                                        multiple
                                        :limit="4"
                                        :on-exceed="handleExceedRestaurant"
                                        :on-success="uploadSuccessRestaurant"
                                        :file-list="restaurantImageList"
                                        list-type="picture">
                                        <el-button size="small" style="width:350px;border-radius:0;"><i class="el-icon-upload"></i>点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip"><i class="el-icon-info"></i>推荐尺寸：289 x 166，最多4张</div>
                                        </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                       
                        <el-form-item label="内容" prop="content">
                            <!-- 内容编辑器 -->
                            <div style="border: 1px solid #ccc; margin-top: 10px;">
                                <!-- 工具栏 -->
                                <Toolbar
                                    style="border-bottom: 1px solid #ccc"
                                    :editor="editor"
                                    :defaultConfig="toolbarConfig"
                                />
                                <!-- 编辑器 -->
                                <Editor
                                    style="height: 400px; overflow-y: hidden;"
                                    :defaultConfig="editorConfig"
                                    v-model="html"
                                    @onChange="onChange"
                                    @onCreated="onCreated"
                                />
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    baseUrl,
    editFoodShop,
    addFoodShop,
} from '@services/tokenService.js';
import {
    getFoodCookingStyle,
    getFoodArea,
    getFoodShopDetail
} from '@services/indexService.js';

import rulesPattern from '@/assets/utils/rulesPattern.js';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
export default {
    name:'',
    components: { 
        Editor,
        Toolbar,
        PersonCenterMenu
    },
    data() {
        return {
            editId: '',
            uploadUrl: `${baseUrl}/api/ZhuJingBanXieHui/UploadFile`,
            useList: [
                {
                    label: '是',
                    value: 1,
                },
                {
                    label: '否',
                    value: 2,
                }
            ],
            mapAreaList: [],
            cookingStyleList: [],
            coverImageList: [],
            restaurantImageList: [],
            restaurantImageUrlList: [],
            tagVlaue: '',
            tagList: [],
            inputVisible: false,
            form:{
                name: '',
                tags: '',
                mapArea: '',
                cookingStyle: '',
                perPrice: '',
                address: '',
                tel: '',
                des: '',
                isUse: '',
                content:'',
                coverImageUrl: '',
                restaurantImageUrls: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入店铺名称', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                mapArea: [
                    { required: true, message: '请选择区域', trigger: 'change' },
                ],
                cookingStyle: [
                    { required: true, message: '请选择菜系', trigger: 'change' },
                ],
                tags: [
                    { required: true, message: '请添加标签', trigger: 'blur' },
                ],
                address: [
                    { required: true, message: '请输入地址', trigger: 'blur' },
                ],
                perPrice: [
                    { required: true, message: '请输入人均价格', trigger: 'blur' },
                ],
                tel: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { pattern: rulesPattern.phoneAndTel, message: '请输入正确的手机号或者座机号格式为：0000-0000000', trigger: 'blur' }
                ],
                restaurantImageUrls:[
                    { required: true, message: '请上传餐厅照片', trigger: 'blur' },
                ],
                coverImageUrl:[
                    { required: true, message: '请上传封面照片', trigger: 'blur' },
                ]
            },
            editor: null,
            html: '<p></p>',
            toolbarConfig: {
                // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
                // excludeKeys: [ /* 隐藏哪些菜单 */ ],
                excludeKeys: [
                    // 'headerSelect',
                    'fullScreen',
                    'group-more-style',
                    'group-video',
                    'group-image'
                ]
            },
            editorConfig: {
                placeholder: '请输入内容...',
                // autoFocus: false,

                // 所有的菜单配置，都要在 MENU_CONF 属性下
                MENU_CONF: {
                    'uploadImage': {
                        server: '/api/upload', // 图片上传地址
                    }
                }
            }
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        companyId() {
            return this.$store.state.permission.companyId;
        },
        companyName() {
            return this.$store.state.permission.companyName;
        },
        loginName() {
            return this.$store.state.permission.loginName;
        }
    },
    created() {
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
            return;
        } 
        this.initUploadImage();
        Promise.all([this.getFoodCookingStyle(), this.getFoodArea()]).then(res => {
            // 编辑
            if(this.$route.query.id) {
                this.editId = this.$route.query.id;
                this.getFoodShopDetail();
            }
        });
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
    },
    methods: {
        initUploadImage() {
            this.editorConfig.MENU_CONF['uploadImage'] = {
                server: this.uploadUrl,
                timeout: 5 * 1000, // 5s

                fieldName: 'file',
                // meta: {},
                metaWithUrl: true, // join params to url
                headers: { Accept: 'text/x-json' },

                maxFileSize: 10 * 1024 * 1024, // 10M

                base64LimitSize: 5 * 1024, // insert base64 format, if file's size less than 5kb

                onBeforeUpload(file) {
                    console.log('onBeforeUpload', file)

                    return file // will upload this file
                    // return false // prevent upload
                },
                onProgress(progress) {
                    console.log('onProgress', progress)
                },
                onSuccess(file, res) {
                    console.log('onSuccess', file, res)
                },
                onFailed(file, res) {
                    alert(res.message)
                    console.log('onFailed', file, res)
                },
                onError(file, err, res) {
                    alert(err.message)
                    console.error('onError', file, err, res)
                },
            }
        },
        getFoodArea() {
            return new Promise((resolve, reject) => {
                getFoodArea().then(res => {
                    console.log(res.Code == 1);
                    if (res.Code == 1) {
                        Object.keys(res.Data).forEach(key => {
                            this.mapAreaList.push({
                                "value": key,
                                "label": res.Data[key],
                            });
                        });
                        resolve(res);
                    } else {
                        this.$message.error("区域请求失败");
                        reject(res);
                    }
                })
            })
        },
        getFoodCookingStyle() {
            return new Promise((resolve, reject) => {
                getFoodCookingStyle().then(res => {
                    if (res.Code == 1) {
                        Object.keys(res.Data).forEach(key => {
                            this.cookingStyleList.push({
                                "value": key,
                                "label": res.Data[key],
                            });
                        });
                        resolve(res);
                    } else {
                        this.$message.error("cookingStyleList请求失败");
                        reject(res);
                    }
                })
            })
        },
        changeArea() {
            console.log(this.form.mapArea);
        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
        },
        onChange(editor) {
            this.form.content = editor.getHtml();
            console.log(this.form.content);
        },
        insertTextHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.insertText(' hello ')
        },
        insertHtmlHandler(content) {
            const editor = this.editor;
            if (editor == null) return;
            editor.setHtml(content);
        },
        printEditorHtml() {
            const editor = this.editor
            if (editor == null) return
            console.log(editor.getHtml())
        },
        disableHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.disable()
        },
        //
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleRemove(file, fileList) {
            // 去删除的文件
            this.coverImageList = this.coverImageList.filter(item => item.url !== file.url);
            this.form.coverImageUrl = '';
        },
        handlePreview(file) {
            console.log(file);
        },
        uploadSuccess(response, file, fileList) {
            let url = response.data.url;
            console.log(file)
            this.coverImageList.push({
                name: file.name,
                url: url
            })
            this.form.coverImageUrl = url;
        },
        // 餐厅照片
        handleExceedRestaurant(files, fileList) {
            this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemoveRestaurant(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleRemoveRestaurant(file, fileList) {
            // console.log(file);
            // 去删除的文件
            this.restaurantImageList = this.restaurantImageList.filter(item => item.url !== file.url);
            this.restaurantImageUrlList = this.restaurantImageUrlList.filter(item => item !== file.url);
            this.form.restaurantImageUrls = this.restaurantImageUrlList.join(',');
            console.log(this.restaurantImageList, this.restaurantImageUrlList,this.form.restaurantImageUrls)
        },
        handlePreviewRestaurant(file) {
            console.log(file);
        },
        uploadSuccessRestaurant(response, file, fileList) {
            console.log(file)
            let url = response.data.url;
            this.restaurantImageList.push({
                name: file.name,
                url: url
            })
            this.restaurantImageUrlList.push(url);
            console.log(this.restaurantImageUrlList);
            this.form.restaurantImageUrls = this.restaurantImageUrlList.join(',');
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.editId !== null && this.editId !== '') {
                        this.editFoodShop();
                    } else {
                        this.addFoodShop();
                    }
                } else {
                    return false;
                }
            });
        },
        addFoodShop() {
            let param = {
                Title: this.form.name,
                SubTitle: this.form.tags,
                ImageUrl: this.form.coverImageUrl, // 封面图路径
                Description: this.form.content,
                HomeImgUrl: this.form.restaurantImageUrls, // 餐厅图片
                Tel: this.form.tel,
                HomeAddress: this.form.address,
                AvgPrice: this.form.perPrice,
                IsTop: this.form.mapArea, // 区域
                IsHome: this.form.cookingStyle, // 菜系
                CreateUserId: this.accountId,
                CompanyId: this.companyId, // 协会id,
                CompanyName: this.companyName, // 协会名称
                AccountName: this.loginName, // 提交人姓名
            };
            addFoodShop(param).then(res => {
                if (res.Code == 1) {
                    this.$message.success("驻京美食保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        editFoodShop() {
            let param = {
                Id: this.editId,
                Title: this.form.name,
                SubTitle: this.form.tags,
                ImageUrl: this.form.coverImageUrl, // 封面图路径
                Description: this.form.content,
                HomeImgUrl: this.form.restaurantImageUrls, // 餐厅图片
                Tel: this.form.tel,
                HomeAddress: this.form.address,
                AvgPrice: this.form.perPrice,
                IsTop: this.form.mapArea, // 区域
                IsHome: this.form.cookingStyle, // 菜系
                CreateUserId: this.accountId,
                CompanyId: this.companyId, // 协会id,
                CompanyName: this.companyName, // 协会名称
                AccountName: this.loginName, // 提交人姓名
            };
            editFoodShop(param).then(res => {
                if (res.Code == 1) {
                    this.$message.success("驻京美食保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        handleClose(tag) {
            this.tagList.splice(this.tagList.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm() {
            let tagVlaue = this.tagVlaue;
            if (tagVlaue) {
                this.tagList.push(tagVlaue);
                this.form.tags = this.tagList.join(",");
            }
            this.inputVisible = false;
            this.tagVlaue = '';
        },
        getFoodShopDetail() {
            let params = {
                id: this.editId
            };
            getFoodShopDetail(params).then(res => {
                if (res.Code === 1) {
                    this.form.name = res.Data.Title;
                    this.form.tags = res.Data.SubTitle;
                    this.tagList = res.Data.SubTitle.split(',');
                    this.form.coverImageUrl = res.Data.ImageUrl;
                    let fileArr = res.Data.ImageUrl.split('/');
                    this.coverImageList = [{
                        name: fileArr[fileArr.length - 1],
                        url: res.Data.ImageUrl
                    }];
                    this.form.tel = res.Data.Tel;
                    this.form.address = res.Data.HomeAddress;
                    this.form.perPrice = res.Data.AvgPrice;
                    this.form.mapArea = res.Data.IsTop;
                    this.form.cookingStyle = res.Data.IsHome;
                    this.form.content = res.Data.Description;
                    this.insertHtmlHandler(res.Data.Description);
                    this.form.restaurantImageUrls = res.Data.HomeImgUrl;
                    this.restaurantImageUrlList = res.Data.HomeImgUrl.split(',');
                    this.restaurantImageUrlList.forEach(item => {
                        if (item) {
                            console.log(item)
                            let fileArr = item.split('/');
                            this.restaurantImageList.push({
                                name: fileArr[fileArr.length - 1],
                                url: item
                            });
                        }
                    })
                } else {
                    this.$message.error("详情请求失败！");
                }
            })

        },
    },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.page-content {
    padding: 30px;
    min-height: 750px;
}
.page-content h3{
    text-align:center;
    color: #262626;
    font-size: 22px;
    text-align: center;
    margin-bottom: 30px;
}
.form{
    /* width: 450px; */
    margin: 0 auto;
}
.vertical-nav li a.active {
    border-left: none;
}
.el-select {
    width: 350px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 350px;
}
.el-button:focus, .el-button:hover {
    color: #fff;
    border-color: #005091;
    background-color: #005091;
}
.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .el-radio {
    padding-bottom: 10px;
  }
.el-upload .el-button:focus, 
.el-upload .el-button:hover{
    background-color: #ecf5ff;
    color: #116EBA; 
}
</style>